import EmptyState from "@/lib/components/EmptyState";
import { canEnlargeWindow, useIsMobile } from "@/lib/use-mobile";
import { useTeamQuery } from "@/lib/queries/team-queries";
import { IconDeviceDesktop, IconVideo } from "@tabler/icons-react";
import { NavigateFunction, useNavigate } from "react-router";
import { useStartDfyOrderMutation } from "../DoneForYou/dfy-order-hooks";

type Props = {
  teamExternalId: string;
  handleCreateVideo: (
    navigate: NavigateFunction,
    teamExternalId: string,
  ) => void;
};

export default function VideosEmptyState({
  teamExternalId,
  handleCreateVideo,
}: Props) {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const { data: team } = useTeamQuery(teamExternalId);
  const startDfyOrderMutation = useStartDfyOrderMutation({
    teamExternalId,
    source: "VIDEOS_PAGE",
  });

  const showDfy = team && !team.isDfyEditorTeam;
  const { header, subHeader } = getTexts(isMobile, !!showDfy);

  return (
    <EmptyState
      icon={
        isMobile ? <IconDeviceDesktop size={24} /> : <IconVideo size={24} />
      }
      header={<span className="text-lg">{header}</span>}
      subHeader={subHeader}
      primaryActionLabel="New video"
      primaryActionOnClick={() => handleCreateVideo(navigate, teamExternalId)}
      primaryActionDisabled={isMobile}
      secondaryActionLabel={showDfy ? "Order video" : undefined}
      secondaryActionOnClick={() => startDfyOrderMutation.mutate()}
    />
  );
}

function getTexts(isMobile: boolean, showDfy: boolean) {
  const dfy = showDfy ? ", or let our team make it for you" : "";
  if (!isMobile) {
    return {
      header: "Create your first video",
      subHeader: `Turn your listing photos into a video in minutes${dfy}.`,
    };
  }
  if (canEnlargeWindow()) {
    return {
      header: "Make your browser window larger",
      subHeader: `The video editor needs a larger window to create your video${dfy}.`,
    };
  }
  return {
    header: "Video editor is available on desktop only",
    subHeader: `Open Amplifiles on a computer to create your video${dfy}.`,
  };
}
